import GeneralLayout from "@/layouts/General"
import { diSiniPs, diSiniImgs } from "@/app/utils/constants"
import NavEngrave from "@/assets/imgs/nav-engrave.png"
import clsx from "clsx"
import DiSiniContent from "@/assets/imgs/di-sini/engrave.jpg"
import GreekHero from "@/components/GreekHero"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HeroSlider from "@/components/slider/HeroSlider"
import ImageSkeleton from "@/components/skeletons/ImageSkeleton"
import { Link } from "react-router-dom"

const DiSini = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1000,
    fade: true,
    pauseOnHover: false
  };

  return (
    <>
      <GeneralLayout bgColor="bg-transparent" hasGreekL={false} contentColor="text-white" relativeCls="relative -top-[50px] z-20">
        <GreekHero>
          <div className="relative">
            <HeroSlider settings={settings} slides={diSiniImgs.slides} title="di sini" subtitle="our restaurant" text1 />
          </div>
        </GreekHero>
        <section>
          <div className="flex justify-center pt-8 pb-12">
            <div className="text-center">
              <span className="font-agcasmlt uppercase text-sm sm:text-xl text-charcoal-black">discover di sini</span>
              <img img="100" src={NavEngrave} className="w-24 mx-auto" />
              <div className="py-10">
                <p className="text-charcoal-black text-lg sm:text-xl lg:text-2xl font-light font-agcasmlt w-[70%] mx-auto">At DI SINI DI SANA, we will harmonize our Eastern cultural heritage with classic Western elements. This will be manifested down to every detail, including the use of traditional classic tiles in our interiors. These tiles, with their rich motifs and colors, will immediately bring to you feelings of both  nostalgia and Eastern warmth to our space.</p>
              </div>
              <div className="border w-28 border-charcoal-black mx-auto"></div>
            </div>
          </div>
          <div className="w-[80%] mx-auto">
            <div className="mb-8">
              <ImageSkeleton isDarker src={DiSiniContent} alt="Traditional Eastern motifs interior design" custCls="h-[380px] object-cover w-full" custH="h-[380px]" />
            </div>
            <div className="sm:flex justify-between">
              <div className="sm:w-1/2">
                <h2 className="max-sm:mb-4 font-agcasmlt uppercase text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-charcoal-black">story behind architecture</h2>
              </div>
              <div className="sm:w-1/2">
                {diSiniPs.map((p, i) => (
                  <p key={i} className={clsx("text-charcoal-black text-lg sm:text-xl lg:text-2xl text-justify inline-block font-light font-agcasmlt", { "mb-4": i < 3 })}>{p}</p>
                ))}
              </div>
            </div>
          </div>
          <div className="pt-5 pb-10 w-[90%] sm:w-[80%] mx-auto flex gap-3 sm:gap-6">
            {diSiniImgs.elevations.map((e, i) => (
              <div key={i} className={clsx({ "w-[40%] sm:w-[43%]": i != 1, "w-[10%] sm:w-[calc(13%-48px)]": i == 1 })}>
                <ImageSkeleton src={e} custCls="w-full h-full" custH="h-24 sm:h-36 md:h-44 lg:h-56 xl:h-72" isDarker />
              </div>
            ))}
          </div>
        </section>
        <section className="bg-[url('/src/assets/imgs/our-story/our-story-bg-mobile.webp')] lg:bg-[url('/src/assets/imgs/our-story/our-story-bg-desktop.webp')] bg-cover bg-center pt-10 pb-4">
          <div>
            <div className="flex max-sm:flex-col gap-2">
              {diSiniImgs.contents.map((c, i) => (
                <div key={i} className="sm:w-1/3">
                  <ImageSkeleton src={c} custCls="w-full object-cover object-center h-[300px] sm:h-[400px]" custH="h-[200px] sm:h-[400px]" />
                </div>
              ))}
            </div>
            <p className="text-charcoal-black text-lg sm:text-xl lg:text-2xl font-light font-agcasmlt w-[75%] mx-auto text-center mt-12">Discover the enchanting world of DI SINI & DI SANA, where the East and West intertwine in perfect harmony. DI SINI, a celebration of rich traditions and avors, and DI SANA, an homage to design and beauty. Experience the exquisite fusion of cultures and embark on a culinary journey inspired by the Rachman family legacy. Stay tuned for updates on this extraordinary destination</p>
          </div>
        </section>
        <section className="pb-10">
          <div className="border w-28 border-charcoal-black mx-auto my-14"></div>
          <div className="flex justify-center">
            {diSiniImgs.menus.map((c, i) => (
              <div key={i} className="px-1.5 sm:px-2 w-1/3">
                <div className="mb-4 sm:mb-6">
                  <ImageSkeleton alt={c.title} src={c.imgPath} isDarker custCls="w-full h-[200px] sm:h-[500px] bg-cover object-cover" custH="h-[200px] sm:h-[500px]" />
                </div>
                <div className="p-1 border border-[#95702e]">
                  <Link to={c.link} className="bg-[#95702e] pt-1 md:pt-2 font-agcasmlt font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white block text-center">
                    {c.title}
                  </Link>
                </div>
                {/* TODO: kaarena belum ada text komen dulu */}
                {/* <div className="py-4 w-[60%] text-center mx-auto">
                    <span className="font-sloopScriptPro text-[20px] leading-[20px] font-light text-charcoal-black">{c.text}</span>
                  </div> */}
              </div>
            ))}
          </div>
          <div className="flex justify-center pt-8 pb-12">
            <div className="text-center">
              <span className="font-agcasmlt uppercase text-sm sm:text-xl text-charcoal-black">dress code</span>
              <img img="100" src={NavEngrave} className="w-24 mx-auto" />
              <div className="py-10">
                <p className="text-charcoal-black text-lg sm:text-xl lg:text-2xl font-light font-agcasmlt w-[70%] mx-auto">"We welcome everyone and want you to be comfortable in your own style - please be yourself and dress as you are."</p>
              </div>
              <div className="border w-28 border-charcoal-black mx-auto"></div>
            </div>
          </div>
        </section>
      </GeneralLayout>
    </>
  )
}

export default DiSini